import React, { useContext, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import PropTypes from 'prop-types';
import NumberFormat from 'react-number-format';
import { ModalContext } from 'App';
import * as c from '../../../../constant';
import * as actions from '../../../../action';

function UpdateDetailsModal({
  updateDetails,
  getDetailsList,
  updateList,
  detailsId,
  newTaxRevenuesId,
  calculationsId,
  updating,
}) {
  const [formData, setFormData] = useState({
    unit: '',
    capacity: '',
    amount: '',
  });

  const setModal = useContext(ModalContext);

  const handleOnSubmit = e => {
    e.preventDefault();
    updateDetails(newTaxRevenuesId, calculationsId, detailsId, formData, () => {
      setModal({ isOpen: false });
      getDetailsList(newTaxRevenuesId, calculationsId);
    });
  };

  const closeModal = e => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  const onSetFormData = () => {
    if (!_.isEmpty(updateList)) {
      const args = {
        ...updateList,
        unit: _.get(updateList, 'unit').toString(),
        capacity: _.get(updateList, 'capacity').toString(),
        amount: _.get(updateList, 'amount').toString(),
      };
      setFormData(_.pick(args, _.keys(c.FORM_DATA_DETAILS)));
    }
  };

  useEffect(() => {
    onSetFormData();
  }, []);

  const onChange = e => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row">
          <div className="col-12 form-group">
            <label className="form-label mb-0">
              Unit
            </label>
            <input
              className="form-control"
              type="text"
              name="unit"
              onChange={onChange}
              value={_.get(formData, 'unit')}
            />
          </div>
          <div className="col-12 form-group">
            <label className="form-label mb-0">
              Capacity
            </label>
            <input
              className="form-control"
              type="text"
              name="capacity"
              onChange={onChange}
              value={_.get(formData, 'capacity')}
            />
          </div>
          <div className="col-12 form-group">
            <label className="form-label mb-0">
              Amount
            </label>
            <NumberFormat
              name="amount"
              id="amount"
              className="form-control"
              onValueChange={values => {
                const { floatValue } = values;
                setFormData({
                  ...formData,
                  amount: `${floatValue || 0.00}`,
                });
              }}
              /* eslint-disable */
              isNumericString={true}
              thousandSeparator={true}
              allowNegative={true}
              allowLeadingZeros={true}
              displayType="input"
              prefix=""
              value={`${_.get(formData, 'amount', 0.00)}` || ''}
              isAllowed={values => {
                const { value } = values;
                return value === '' || value <= 999999999999999;
              }}
            />
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <button
            disabled={updating}
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary mr-3"
          >
            <span className="font-weight-bold">
              {updating ? <i className="fa fa-spin fa-spinner" /> : `Submit`}
            </span>
          </button>
          <button
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

UpdateDetailsModal.propTypes = {
  updateList: PropTypes.instanceOf(Object).isRequired,
  updateDetails: PropTypes.instanceOf(Function).isRequired,
  getDetailsList: PropTypes.instanceOf(Function).isRequired,
  detailsId: PropTypes.string.isRequired,
  newTaxRevenuesId: PropTypes.string.isRequired,
  calculationsId: PropTypes.string.isRequired,
  updating: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ api }) => ({
  updating: api.loading.indexOf(c.UPDATE_DETAILS_GARBAGE) > -1,
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(UpdateDetailsModal);
